import { Breadcrumbs, Stack, Typography } from '@ethings/ui-toolkit';
import { Link } from '@mui/material';
import { FC, type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useHref } from 'react-router-dom';
import { Icon } from '../../components';
import { T_MANY } from '../../constants';
import { useCustomRoutes } from '../../hooks';
import { CreatePage } from '../create';
import { CreateSubscriptionController } from './create-subscription-controller';

interface CreateSubscriptionPageProps {
  isProfilePage?: boolean;
}

export const CreateSubscriptionPage: FC<CreateSubscriptionPageProps> = ({ isProfilePage = false }) => {
  const { subscription: subscriptionRoute, subscriptions: subscriptionsRoute } = useCustomRoutes();
  const { t } = useTranslation(['admin', 'common']);
  const href = useHref(isProfilePage ? `/profile/${subscriptionRoute}` : `/${subscriptionsRoute}`);

  const renderPageContent = (): JSX.Element => {
    return <>
      <Stack direction="column" flex={[2, 2]}>
        <CreateSubscriptionController isProfilePage={isProfilePage} />
      </Stack>
      <Stack direction="column" flex={[3, 3]} />
    </>;
  };

  const breadcrumbs = (
    <Breadcrumbs>
      <Link
        color="inherit"
        href={href}
        underline="hover"
      >
        {t('common:terms.subscription', { count: T_MANY })}
      </Link>
      <Typography color="text.primary" data-testid="subscription-detail-subtitle-breadcrumb">{t('admin:page.create-subscription.sub-title')}</Typography>
    </Breadcrumbs>
  );

  return (
    <CreatePage
      actions={[]}
      breadcrumbs={breadcrumbs}
      data-testid='subscription-create'
      pageIcon={<Icon icon="AlertIcon" />}
      pageTitle={t('admin:page.create-subscription.title')}
      renderPageContent={renderPageContent}
    />
  );
};
